import { environmentVariables } from './environmentVariables';

export class Log {
  static debug(...msg: any[]) {
    if (
      environmentVariables.REACT_APP_NODE_ENV === 'development' &&
      environmentVariables.REACT_APP_HTTP_REQUEST_LOG_CONSOLE
    ) {
      /* eslint-disable no-console */
      console.log(...msg);
    }
  }

  static error(...msg: any[]) {
    /* eslint-disable no-console */
    console.log('ERROR', ...msg);
  }
}
